export default "__VITE_ASSET__C114ubz$__"